var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTablePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 110,
    viewBox: "0 0 200 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_518_38575)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 110,
    rx: 8,
    fill: "url(#paint0_linear_518_38575)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_518_38575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6102 42L19 44.5454L29.6883 55L19 65.4484L21.6102 68L34.9023 55L21.6102 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7015 42L29.0977 44.5454L39.786 55L29.0977 65.4484L31.7015 68L45 55L31.7015 42Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_518_38575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.128 43.4932H71.2109V66.4998H75.128V43.4932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8032 43.4932H81.8862V66.4998H85.8032V43.4932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6017 52.4139L72.5391 56.1455L73.804 59.8104L84.8666 56.0788L83.6017 52.4139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7593 43.5244H53V47.3968H66.7593V43.5244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8413 45.4609H57.9243V66.4761H61.8413V45.4609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8538 68L88.5142 54.2071L97.1316 42L100.34 44.2128L93.3327 54.1395L102 65.695L98.8538 68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.427 52.2402H90.9268V56.1126H100.427V52.2402Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_518_38575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.357 67.0625L153.135 49.8269L147.261 67.0307L143.364 65.724L151.132 42.9684L152.851 42.9556L155.022 42.9365L163.234 65.6921L159.357 67.0625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.16 60.0135L153.304 57.1875L150.449 60.0135L153.304 62.8395L156.16 60.0135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.835 68V42H131.951V62.1486L139.306 59.4587L140.736 63.2832L127.835 68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.116 67.7893H110V42.21L125.606 50.7576L114.161 62.6709L114.116 62.6262V67.7893ZM114.116 49.1195V56.8067L118.953 51.7711L114.116 49.1195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.81 57.5148L163.241 44.0845L166.944 42.3125L171.646 51.9247L176.284 42.3189L180 44.0781L173.52 57.502L169.81 57.5148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.675 55.124H169.559V67.6874H173.675V55.124Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    width: 200,
    height: 110,
    fill: "url(#pattern0_518_38575)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_518_38575",
    patternContentUnits: "objectBoundingBox",
    width: 1.068,
    height: 3.79636
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_518_38575",
    transform: "scale(0.004 0.00727273)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_518_38575",
    x1: 0,
    y1: 55,
    x2: 200,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B8BB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_518_38575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 110,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_518_38575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(19 42)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_518_38575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 26,
    fill: "white",
    transform: "translate(53 42)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_518_38575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 26,
    fill: "white",
    transform: "translate(110 42)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_518_38575",
    width: 267,
    height: 522,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablePlay);
export default __webpack_public_path__ + "static/media/tablePlay.2acbfe3182588b569b988a3676ebcb60.svg";
export { ForwardRef as ReactComponent };